<template>
  <div class="mainWeb">
    <el-row class="headTop">
      <span v-if="showShop">
        分店：<el-select class="w150 mr20" v-model="params.shopNum" clearable  placeholder="请选择分店">
          <el-option
          v-for="item in this.shopList"
          :key="item.shopNum"
          :label="item.name"
          :value="item.shopNum"
          ></el-option>
        </el-select>
      </span>
        私教课名：<el-input
          class="w150"
          placeholder="请输入私教项目名"
          v-model="params.name"
          clearable>
        </el-input>
        <el-button class="ml20" style="width:100px"   type="primary" icon="el-icon-search"  @click="queryList()">查询</el-button>
    </el-row>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="线下私教课" name="offLine">
        <offlineCoach :tableDataOff="tableDataOff" :queryParams="params" :shopListNew="shopList" @getTableDataOff="getTableDataOff"></offlineCoach>
      </el-tab-pane>
      <el-tab-pane label="线上私教课" name="onLine">
        <onlineCoach :tableDataOn="tableDataOn" :queryParams="params"  :shopListNew="shopList" @getTableDataOn="getTableDataOn"></onlineCoach>
      </el-tab-pane>
    </el-tabs>
    <el-row class="pageination">
      <el-col>
        <el-pagination
          style="textAlign:center;marginTop:10px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[20, 40, 80, 100]"
          :page-size="20"
          layout="total, sizes, prev, pager, next, jumper"
          :total="this.total"
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {getPtClass, getShops,getInfI} from "../../api/configApi";
// import onlineCard from './onlineCard'
import EditorBar from '../../components/wangEnduit'
import offlineCoach from './offlineCoach'
import onlineCoach from './onlineCoach'
let that;
export default {
  data() {
    return {
      activeName:'offLine',
      loading: true,
      dialogVisible: false,
      hideUpload:false,
      showQuery: false,
      showShop:false,
      isClear: false,
      name:'',
      date:[],
      fileList:[],
      roomList:[],
      optionsJL:[],//教练列表
      tableData:[],
      tableDataOff:[],
      tableDataOn:[],
      //分店列表
      shopList:[],
      shopListAll:JSON.parse(sessionStorage.getItem('shopListAll')),
      total: 0,
      currentPage: 1,
      params: {
        shopNum:null,
        name:null,
        pageNo: 1,
        pageSize: 20
      }
    }
  },
  components:{
    // onlineCard,
    EditorBar,
    offlineCoach,
    onlineCoach
  },
  beforeCreate(){
    that = this
  },
  created(){
    
  },
  mounted() {
    
    if(sessionStorage.getItem('shopList')){
      this.shopList = JSON.parse(sessionStorage.getItem('shopList'))
    }else{
      this.getShopsList()
    }
    if(JSON.parse(sessionStorage.getItem('userinfo')).shopNum!=null){
      this.params.shopNum = this.shopList[0].shopNum
      this.showShop = false
    } else{
      this.showShop = true
    }
    this.getTableListOff()
  },
  filters:{
    changeType(value){
      if (that.shopListAll.find(i => {
        return i.shopNum == value
        })) {
        return that.shopListAll.find(i => {
            return i.shopNum == value
        }).name
      }
    }
  },
  methods: {
    //查询分店
    getShopsList(){
      getShops({isWeb:1}).then((res)=>{
        this.shopList = res.data
        if(JSON.parse(sessionStorage.getItem('userinfo')).shopNum!=null){
          this.params.shopNum = this.shopList[0].shopNum
          this.showShop = false
        } else{
          this.showShop = true
        }
      })
    },
    queryList(){
      // alert(this.activeName)
      if(this.params.shopNum==''){
        this.params.shopNum =null
      }
      if(this.activeName == 'onLine'){
        this.params.pageNo = 1
        this.currentPage = 1;
        this.getTableList()
      }else{
        this.params.pageNo = 1
        this.currentPage = 1;
        this.getTableListOff()
      }
      
    },
    handleClick(tab) {
      this.params.shopNum =null
      this.params.name = null
      this.params.pageSize=20
      this.params.pageNo =1
      if(tab.name == 'onLine'){
        this.getTableList()
      } else {
        this.getTableListOff()
      }
    },
    getTableDataOff(data){
      this.tableDataOff = data.info
      this.total = data.total
    },
    getTableDataOn(data){
      this.tableDataOn = data.info
      this.total = data.total
    },
    getTableListOff(){
      getInfI(this.params).then((res)=>{
        if(res.msg=='success'){
          this.tableDataOff = res.data.info
          this.total = res.data.total
        }else {
          this.$message.error(res.data)
        }
        this.loading= false
      })
    },
    getTableList(){
      getPtClass(this.params).then((res)=>{
        if(res.msg=='success'){
          // this.tableData = res.data.info
          this.tableDataOn = res.data.info
          this.total = res.data.total
          // console.log(this.tableData)       
        }else {
          this.$message.error(res.data)
        }
        this.loading = false
      })
    },
      //分页
    handleSizeChange(val) {
      this.params.pageSize = val;
      this.params.pageNo = 1;
      this.currentPage = 1;
      if(this.activeName == 'onLine'){
        this.getTableList()
      } else {
        this.getTableListOff()
      }
    },
    handleCurrentChange(val) {
      this.params.pageNo = val;
      if(this.activeName == 'onLine'){
        this.getTableList()
      } else {
        this.activeName == 'offLine'
        this.getTableListOff()
      }
    },
  }
}
</script>
<style scoped lang="scss">
.tableList {
  width: 100%;
  margin-top: 20px;
  /* height: 73vh; */
  overflow-y: auto;
  padding: 20px;
  background: #ffffff;
  box-shadow: none;
  border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// coach.vue?bf07fda8